'use strict';

var cached = [];

exports.loadScript = function (src, cb) {
    if (~cached.indexOf(src)) {
        cb();
        return;
    }

    var ele = document.createElement('script');
    ele.src = src;
    ele.onload = function () {
        cached.push(src);
        cb();
    };

    document.getElementsByTagName('head')[0].appendChild(ele);
};